import actionTypes from "../actions/actionTypes";

const initialState = {
  error: null,
  loading: false,
  workitems: [],
  inputs: {
    state: "",
    text: ""
  },
  filters: {
    status: "In Progress"
  },
  order: null
};

const worklistFilterReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.CHANGE_WORKLIST_FILTER:
      return {
        ...state,
        filters: { ...state.filters, [payload.name]: payload.value }
      };
    case actionTypes.RESET_WORKLIST_FILTER:
    case actionTypes.RESET_WORK_ITEMS:
      return { ...state, filters: { status: "In Progress" } };
    case actionTypes.FETCH_WORK_ITEMS:
      return { ...state, error: null, loading: true };
    case actionTypes.FETCH_WORK_ITEMS_SUCCESS:
      return { ...state, workitems: payload, loading: false };
    case actionTypes.FETCH_WORK_ITEMS_FAILED:
      return { ...state, error: payload, workitems: [], loading: false };
    case actionTypes.ORDER_WORKLIST:
      return { ...state, order: payload };
    case actionTypes.CHANGE_FILTER_INPUT:
      return {
        ...state,
        inputs: { ...state.inputs, [payload.field]: payload.value }
      };
    case actionTypes.RESET_FILTER_INPUT:
      return { ...state, inputs: { state: "", text: "" } };
    default:
      return state;
  }
};

export default worklistFilterReducer;
